<template>
  <div>
    <el-card class="mb-3" shadow="never">
      <div class="d-flex align-items-center" style="overflow:hidden;">
        <div class="customer-vip-wrapper">
          <div class="customer-vip" />
        </div>
        <div class="flex-1 ml-2">
          <h5 style="color: #101010;">
            {{ $l('form_header_create') || '创建新客户档案' }}
          </h5>
          <p style="font-size:14px;color: #6C6C6C;" class="m-0 text-truncate">
            {{
              $l('form_desc_create') ||
                '根据操作指引填写客户基本信息、客户部门及产品线、客户方联系人、客户账务信息、配置对接客户的服务团队成员'
            }}
          </p>
        </div>
      </div>
    </el-card>

    <el-card shadow="never">
      <div class="switch-tabs_wrappers">
        <div class="switch-tabs">
          <div
            v-for="item in switchTabs"
            :key="item.value"
            class="switch-tabs_items"
            :class="{ active: item.value === activeTab }"
          >
            <span>{{ item.label }}</span>
          </div>
        </div>
      </div>

      <div class="my-4">
        <keep-alive>
          <component
            v-bind:is="activeTab"
            :ref="activeTab"
            :custCode.sync="custCode"
            @close="$emit('close')"
            @reload="$emit('reload')"
          />
        </keep-alive>
      </div>

      <div class="d-flex justify-content-end mb-1">
        <el-button
          v-if="showPreviousStep"
          type="primary"
          size="small"
          @click="previousStep"
        >
          {{ $l('btn_previousStep') || '返回上一步' }}
        </el-button>
        <el-button
          v-if="showNextStep"
          type="primary"
          size="small"
          @click="nextStep"
        >
          {{ $l('btn_nextStep') || '下一步' }}
        </el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import CustBase from './components/cust-base'
import CustContact from './components/cust-contact'
import CustCategoryBrandDep from './components/cust-category-brand-dep'
import CustFinance from './components/cust-finance'
import CustFactory from './components/cust-factory'
import CustSales from './components/cust-sales'
import CustFolder from './components/cust-folder'
import CustComplete from './components/cust-complete'
export default {
  name: 'customerManage-info-create',
  components: {
    CustBase,
    CustContact,
    CustCategoryBrandDep,
    CustFinance,
    CustFactory,
    CustSales,
    CustFolder,
    CustComplete,
  },
  data() {
    return { activeTab: 'cust-base', custCode: '' }
  },
  computed: {
    switchTabs() {
      return [
        {
          label: this.$l('switchTabs_label_base') || '客户基本信息',
          value: 'cust-base',
        },
        {
          label: this.$l('switchTabs_label_contact') || '客户方联系人',
          value: 'cust-contact',
        },
        {
          label:
            this.$l('switchTabs_label_categoryBrandDep') || '客户品类及部门',
          value: 'cust-category-brand-dep',
        },
        {
          label: this.$l('switchTabs_label_finance') || '财务信息',
          value: 'cust-finance',
        },
        {
          label: this.$l('switchTabs_label_factory') || '验厂相关',
          value: 'cust-factory',
        },
        {
          label: this.$l('switchTabs_label_sales') || '业务人员配置',
          value: 'cust-sales',
        },
        {
          label: this.$l('switchTabs_label_folder') || '客人文档',
          value: 'cust-folder',
        },
        {
          label: this.$l('switchTabs_label_complete') || '创建完成',
          value: 'cust-complete',
        },
      ]
    },
    showPreviousStep() {
      const findIndex = this.switchTabs.findIndex(
        (item) => item.value == this.activeTab
      )
      return findIndex !== 0 && findIndex !== this.switchTabs.length - 1
    },
    showNextStep() {
      const findIndex = this.switchTabs.findIndex(
        (item) => item.value == this.activeTab
      )
      return findIndex !== this.switchTabs.length - 1
    },
  },
  methods: {
    async activeTabComplete() {
      const ref = this.$refs[this.activeTab]
      if (!ref) return
      try {
        return await ref.complete()
      } catch (e) {
        return false
      }
    },
    async nextStep() {
      const findIndex = this.switchTabs.findIndex(
        (item) => item.value == this.activeTab
      )
      if (findIndex < 0 || findIndex == this.switchTabs.length - 1) return
      if (!(await this.activeTabComplete())) return
      this.activeTab = this.switchTabs[findIndex + 1].value

      this.$emit('reload')
    },
    previousStep() {
      const findIndex = this.switchTabs.findIndex(
        (item) => item.value == this.activeTab
      )
      if (findIndex < 0 || findIndex == 0) return
      this.activeTab = this.switchTabs[findIndex - 1].value
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-card {
    border: none;
  }
  .el-card__body {
    padding: 16px;
  }
}
.customer-vip-wrapper {
  width: 60px;
  height: 60px;
  min-width: 60px;
  background-image: url('./polygonal.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  display: flex;
  align-items: center;
  justify-content: center;
  .customer-vip {
    width: 30px;
    height: 30px;
    background-image: url('./vip-icon.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
}

.switch-tabs_wrappers .switch-tabs {
  display: flex;
  .switch-tabs_items {
    padding-top: 4px;
    padding-bottom: 10px;
    padding-left: 2px;
    padding-right: 2px;
    color: #6c757d;
    font-size: 14px;
    margin-right: 26px;
    cursor: pointer;
    min-width: max-content;
    border-bottom: 3px solid transparent;
  }
  // .switch-tabs_items:hover,
  .switch-tabs_items.active {
    color: #007bff;
    border-color: #1989fa;
  }
  // .switch-tabs_items.disabled {
  //   cursor: no-drop;
  // }
  // .switch-tabs_items.disabled:hover {
  //   color: #8cc5ff;
  //   border-color: #7ab8f6;
  // }
  .switch-tabs_items:last-child {
    margin-right: 0;
  }
}
</style>
